import React from "react";
export default function Coin({name,price,symbol,icon}){
    return(
        <div className="coin">
            <h1>Name:{name}</h1>

        <img src={icon}/>
             <h5>Price:${price}</h5>
             <h5>Symbol:{symbol}</h5>
        </div>
    )
}